import { h } from 'vue'
import { DesktopOutlined, InboxOutlined } from '@ant-design/icons-vue'
import MainLayout from '@/layouts/MainLayout.vue'
import LoginView from '@/views/login/LoginView.vue'
import FundView from '@/views/reference/fund/FundView.vue'
import BookView from '@/views/reference/book/BookView.vue'
import CounterPartyView from '@/views/reference/counterparty/CounterPartyView.vue'
import CustodianView from '@/views/reference/custodian/CustodianView.vue'
import CustodianAccountView from '@/views/reference/custodianaccount/CustodianAccountView.vue'
import BrokerAccountView from '@/views/reference/brokeraccount/BrokerAccountView.vue'

import FutureOptionView from '@/views/security/futureoption/FutureOptionView.vue'
import StockBondView from '@/views/security/stockbond/StockBondView.vue'
import BasketIndexView from '@/views/security/basketindex/BasketIndexView.vue'
import InterestRateView from '@/views/security/interestrate/InterestRateView.vue'
import SwapView from '@/views/security/swap/SwapView.vue'
import CcyView from '@/views/security/currency/CcyView.vue'
import IssuerView from '@/views/security/issuer/IssuerView.vue'

const routes = [
  {
    path: '/login',
    name: 'login',
    icon: () => h(InboxOutlined),
    meta: {
      title: 'Login',
    },
    component: LoginView,
  },
  {
    path: '/',
    name: 'reference',
    icon: () => h(DesktopOutlined),
    redirect: {
      name: 'fundView',
    },
    meta: {
      title: 'Reference',
    },
    component: MainLayout,
    children: [
      {
        path: 'fund',
        name: 'fundView',
        component: FundView,
        meta: {
          title: 'Fund',
        },
      },
      {
        path: 'book',
        name: 'bookView',
        component: BookView,
        meta: {
          title: 'Book',
        },
      },
      {
        path: 'counterParty',
        name: 'counterPartyView',
        component: CounterPartyView,
        meta: {
          title: 'CounterParty',
        },
      },
      {
        path: 'custodian',
        name: 'custodianView',
        component: CustodianView,
        meta: {
          title: 'Custodian',
        },
      },
      {
        path: 'custodianAccount',
        name: 'custodianAccountView',
        component: CustodianAccountView,
        meta: {
          title: 'Custodian Account',
        },
      },
      {
        path: 'broerAccount',
        name: 'brokerAccountView',
        component: BrokerAccountView,
        meta: {
          title: 'Broker Account',
        },
      },
    ],
  },
  {
    path: '/',
    name: 'security',
    icon: () => h(InboxOutlined),
    meta: {
      title: 'Security',
    },
    redirect: {
      name: 'futureOptionView',
    },
    component: MainLayout,
    children: [
      {
        path: 'issuer',
        name: 'issuerView',
        component: IssuerView,
        meta: {
          title: 'Issuer',
        },
      },
      {
        path: 'futureOption',
        name: 'futureOptionView',
        component: FutureOptionView,
        meta: {
          title: 'Future & Option',
        },
      },
      {
        path: 'stockbond',
        name: 'stockBondView',
        component: StockBondView,
        meta: {
          title: 'Stock & Bond',
        },
      },
      {
        path: 'basketindex',
        name: 'basketIndexView',
        component: BasketIndexView,
        meta: {
          title: 'Basket & Index',
        },
      },
      {
        path: 'interestrate',
        name: 'interestRateView',
        component: InterestRateView,
        meta: {
          title: 'Interest Rate',
        },
      },
      {
        path: 'swap',
        name: 'swapView',
        component: SwapView,
        meta: {
          title: 'Swap',
        },
      },
      {
        path: 'ccy',
        name: 'ccyView',
        component: CcyView,
        meta: {
          title: 'Ccy',
        },
      },
    ],
  },
]

export default routes
